module.exports = __webpack_public_path__ + "static/PalomaArteDeImpactar-b278164332b6016680c4b6aa0d955dce.png";